module.exports = __webpack_public_path__ + "static/media/logo.3b2e81a1.png";